import Page from '@services/page'
import scrollbar from '@services/scrollbar'
import grouper from '@services/grouper'
import anchorScroll from '@services/anchor-scroll'
import sections from '@services/sections'
import textSplitter from '@services/text-splitter'
import mouseProximity from '@services/mouse-proximity'
import visibility from '@services/visibility'
import {subscribe} from '@services/events'
import {isTouch,isFirefox,isSafari} from '@services/browser'

(function services(){
    !isTouch && !isFirefox && !isSafari && scrollbar();

    let destructors;

    subscribe(document,'page:fullyInitialized',()=>{
        if(destructors){
            destructors.forEach(destroy => destroy&&destroy());
        }

        grouper();
        textSplitter('.split-text,blockquote.animated>p').forEach(text=>{
            if(text.parentNode.tagName === 'BLOCKQUOTE'){
                const length = text.style.getPropertyValue('--length');
                if(text.parentNode.nextSibling){
                    text.parentNode.nextSibling.style.setProperty('--length',length);
                }
            }
        });

        destructors = [
            mouseProximity(),
            anchorScroll(),
            visibility(),
            sections({selector:'.page-section, .article-header'})
        ];
    });
})()


let page = new Page();
if(module.hot) {
    module.hot.accept(()=>{
        if(page) {
            page.destroy();
        }
        page = new Page();
    })
}